Constants = require("./constants")

exports.Actions = class Actions
  constructor: (@lessonId, @slideId) ->

  # Dispatches an action to the learners app
  dispatch: ({ type, payload }) ->
    # The event must be prefixed with 'event:'
    Application.publish("event:#{type}") payload

  uploadMediaFromSource: (source, mediaType) -> @dispatch {
    type: Constants.UPLOAD_MEDIA_FROM_SOURCE
    payload: {
      @lessonId
      @slideId
      source
      type: mediaType
    }
  }

  getMediaForSlide: -> @dispatch {
    type: Constants.GET_MEDIA_FOR_SLIDE
    payload: {
      @lessonId
      @slideId
    }
  }

  postMediaForSlide: ({ url, title }) -> @dispatch {
    type: Constants.POST_MEDIA_FOR_SLIDE
    payload: {
      @lessonId
      @slideId
      url
      title
    }
  }

  unsetAutoOpenComment: -> @dispatch {
      type: Constants.UNSET_AUTO_OPEN_COMMENT
      payload: {}
  }

